import { PhoneNumberType } from "../../constants/enum";
import IPaymentCard from "../../models/Form/IPaymentCard";

export const initialState: IPaymentCard = {
    CardHolderName: '',
    CardNumber: '',
    CVV: '',
    ExpiryDate: '',
    CardHolderEmail: '',
    CardHolderPhone: '',
    CardHolderPhoneType: PhoneNumberType.Mobile,
    // Is3DSecure: false,
}